import { render, staticRenderFns } from "./ServiceAnalyticsPageHeader.vue?vue&type=template&id=0cefd96f&"
import script from "./ServiceAnalyticsPageHeader.vue?vue&type=script&setup=true&lang=js&"
export * from "./ServiceAnalyticsPageHeader.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports